<template>
  <div
    id="addBadge"
    class="tab-pane "
    role="tabpanel"
  >
    <!-- .student -->
    <b-form-group
      id="input-group-1"
      :label="$t('results.student')"
      label-for="input-1"
    >
      <Select2
        id="input-1"
        v-model="newItem.student"
        :options="studentOptions"
      />
    </b-form-group>        <!-- .exam -->
    <b-form-group
      id="input-group-2"
      :label="$t('results.exam')"
      label-for="input-2"
    >
      <Select2
        id="input-2"
        v-model="newItem.exam"
        :options="examOptions"
      />
    </b-form-group>        <!-- .result -->
    <b-form-group
      id="input-group-3"
      :label="$t('results.result')"
      label-for="input-3"
    >
      <b-form-input
        id="input-3"
        v-model="newItem.result"
        type="text"
        :placeholder="$t('results.result')"
      />
    </b-form-group>
    <!-- .answers -->
    <b-form-group
      id="input-group-4"
      :label="$t('results.answers')"
      label-for="input-4"
    >
      <b-form-input
        id="input-4"
        v-model="newItem.answers"
        type="text"
        :placeholder="$t('results.answers')"
      />
    </b-form-group>

    <div class="form-group">
      <button
        type="button"
        class="btn btn-primary"
        @click="submit()"
      >
        <i class="fa fa-plus" /> {{ $t('site.save') }}
      </button>
    </div>
  </div>
</template>

<script>
import Select2 from 'v-select2-component'
import Controller from '../../../../Controllers/ResultsController'
import config from '../../../../config/config'

const controller = new Controller()
export default {
  name: 'ResultsForm',
  components: {
    Select2,
  },
  props: ['newItem'],
  data() {
    return {
      file: {},
      
      student: [],
      exam: [],

    }
  },
  methods: {
       goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      controller.From(this.newItem, 'FormData')
    },
    // async created() {
    //    const data = await controller.created();
    //    data.
    // },

  },

}
</script>
